const TableRowSkeleton = () => (
  <tr className="w-full border-b border-gray-100 last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg">
    
    {/* Name */}
    <td className="px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    {/* Actions */}
    <td className="whitespace-nowrap px-6 py-3">
      <div className="flex items-center justify-start gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      </div>
    </td>
  </tr>
);

const MobileCardSkeleton = () => (
  <div className="mb-2 w-full rounded-md bg-white p-4">
    {/* Name */}
    <div className="h-6 w-32 rounded bg-gray-200 mb-4"></div>    
    {/* Actions */}
    <div className="w-full flex items-center justify-center gap-2">
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
    </div>
  </div>
);

export default function DietaryPreferencesSkeleton() {
  return (
    <div className="animate-pulse max-w-2xl">
      {/* Mobile layout */}
      <div className="lg:hidden">
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>            
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </tbody>
      </table>
    </div>
  );
}



